import { useState } from 'react';
import { Alert, Button, Group, Stack, Text, TextInput, Title } from '@mantine/core';
import { api } from '../api/client';

export function MembershipsPage() {
  const [subject, setSubject] = useState('');
  const [estate, setEstate] = useState('slacker');
  const [tenant, setTenant] = useState('');
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState('');
  async function update(enabled: boolean) {
    setBusy(true); setMessage('');
    try {
      await api.put('/api/v1/internal/router-memberships', { subject, estate, tenant, enabled });
      setMessage(enabled ? 'Grant saved. The user can enroll a device for this company.' : 'Grant revoked. Existing devices lose access on their next request.');
    } catch { setMessage('The membership update failed.'); }
    finally { setBusy(false); }
  }
  return <Stack maw={640}><Title order={1}>Device membership grants</Title><Text>Grant a verified Firebase subject access to one tenant. Revoking a grant disables its devices. Re-granting access requires new device enrollment.</Text>
    <TextInput label="Firebase subject (UID)" value={subject} onChange={(e) => setSubject(e.currentTarget.value)} />
    <TextInput label="Estate" value={estate} onChange={(e) => setEstate(e.currentTarget.value)} />
    <TextInput label="Tenant" value={tenant} onChange={(e) => setTenant(e.currentTarget.value)} />
    <Group><Button disabled={busy || !subject || !estate || !tenant} onClick={() => void update(true)}>Grant access</Button><Button color="red" variant="light" disabled={busy || !subject || !estate || !tenant} onClick={() => void update(false)}>Revoke access</Button></Group>
    {message && <Alert>{message}</Alert>}
  </Stack>;
}
